var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { and, not, or, reads, readOnly } from '@ember/object/computed';
import { A } from '@ember/array';
import { computed } from '@ember/object';
import Service, { inject as service } from '@ember/service';
let UserPermissions = (_dec = readOnly('currentUserData.data'), _dec2 = reads('data.canSeeContracts'), _dec3 = and('data.canUseCustomerListInTransactions', 'data.shouldShowCustomerList'), _dec4 = reads('data.canViewGiftCardHistoryEvents'), _dec5 = not('data.canSeeRewardsTab'), _dec6 = not('data.shouldShowMarketing'), _dec7 = reads('data.shouldShowMarketing'), _dec8 = reads('data.canMultiunit'), _dec9 = or('data.canUseCardOnFileInIosRegister', 'data.canUseCardOnFileInAndroidRegister'), _dec10 = or('data.canUseVoidsIos', 'data.canUseCompsIos'), _dec11 = reads('data.isInCountryWithFlexibleCloseOfDay'), _dec12 = computed('data.currencyCode'), _dec13 = reads('data.canReportsSeeDepositLinksInTransactionBlade'), _dec14 = reads('data.canSeeRiskManagerNotEnrolledFeatures'), _class = class UserPermissions extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentUserData", _descriptor, this);
    _initializerDefineProperty(this, "data", _descriptor2, this);
    // CONTRACTS
    _initializerDefineProperty(this, "canSeeContracts", _descriptor3, this);
    // CUSTOMER DIRECTORY
    _initializerDefineProperty(this, "canUseTransactionCustomerName", _descriptor4, this);
    // GIFT CARDS
    _initializerDefineProperty(this, "canViewGiftCardHistoryEvents", _descriptor5, this);
    // LOYALTY
    _initializerDefineProperty(this, "cannotSeeRewardsTab", _descriptor6, this);
    // MARKETING
    _initializerDefineProperty(this, "cannotShowMarketing", _descriptor7, this);
    _initializerDefineProperty(this, "canShowMarketing", _descriptor8, this);
    // MULTIUNIT
    _initializerDefineProperty(this, "isMultiunit", _descriptor9, this);
    // PAYMENTS
    _initializerDefineProperty(this, "canUseCardOnFileInRegister", _descriptor10, this);
    _initializerDefineProperty(this, "useCompOrVoidReasons", _descriptor11, this);
    _initializerDefineProperty(this, "canSeeFlexibleSettlement", _descriptor12, this);
    // REPORTS
    _initializerDefineProperty(this, "canReportsSeeDepositLinksInTransactionBlade", _descriptor13, this);
    // RISK
    _initializerDefineProperty(this, "canSeeRiskManagerNotEnrolledFeatures", _descriptor14, this);
  }
  get canUseSwedishRounding() {
    const currencies = A(['AED', 'ARS', 'AUD', 'BAM', 'BRL', 'CAD', 'CHF', 'CNY', 'DKK', 'EGP', 'HKD', 'ILS', 'INR', 'ISK', 'MXN', 'NZD', 'SGD', 'USD', 'ZAR']);
    return currencies.includes(this.data.currencyCode);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUserData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "canSeeContracts", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "canUseTransactionCustomerName", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "canViewGiftCardHistoryEvents", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "cannotSeeRewardsTab", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "cannotShowMarketing", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "canShowMarketing", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isMultiunit", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "canUseCardOnFileInRegister", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "useCompOrVoidReasons", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "canSeeFlexibleSettlement", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "canUseSwedishRounding", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "canUseSwedishRounding"), _class.prototype), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "canReportsSeeDepositLinksInTransactionBlade", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "canSeeRiskManagerNotEnrolledFeatures", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { UserPermissions as default }; // This is how TypeScript knows how to look up the service.
/** @hidden */